import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Box,
  Avatar,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useAuth } from "../hooks/useAuth";
import Auth from "../helpers/Auth";

interface HeaderProps {
  onMenuToggle: () => void;
  drawerWidth: number;
}

export function Header({ onMenuToggle, drawerWidth }: HeaderProps) {
  const { user } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const displayName = user?.firstName?.trim() || user?.lastName?.trim() || "Admin";
  const displayInitial = displayName.charAt(0).toUpperCase();
  const roleName = user?.role === "superadmin" ? "SuperAdmin" : "Administrator";

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleMenuClose();
    await Auth.deauthenticateLocalUser();
    window.location.reload();
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        width: { md: `calc(100% - ${drawerWidth}px)` },
        ml: { md: `${drawerWidth}px` },
        transition: "width 225ms cubic-bezier(0.4, 0, 0.2, 1), margin-left 225ms cubic-bezier(0.4, 0, 0.2, 1)",
        bgcolor: "#ADAEAA",
      }}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          edge="start"
          onClick={onMenuToggle}
          sx={{ mr: 2, display: { md: "none" } }}
        >
          <MenuIcon />
        </IconButton>

        <Typography sx={{ flexGrow: 1, color: "#fff", fontSize: 13, fontWeight: 400 }}>
          Kranzler Eck | {roleName}
        </Typography>

        <Box
          onClick={handleMenuOpen}
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            gap: 1,
          }}
        >
          <Box sx={{ display: { xs: "none", sm: "flex" }, alignItems: "center", gap: 0.5 }}>
            <Typography sx={{ color: "#fff", fontSize: 13, fontWeight: 500 }}>
              Hallo,
            </Typography>
            <Typography sx={{ color: "#fff", fontSize: 13, fontWeight: 600, textTransform: "uppercase" }}>
              {displayName}
            </Typography>
          </Box>
          <Avatar
            variant="rounded"
            sx={{ width: 35, height: 35, bgcolor: "brand.main", fontSize: 16, borderRadius: "5px" }}
          >
            {displayInitial}
          </Avatar>
        </Box>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MenuItem onClick={handleLogout}>Ausloggen</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
